import { Hook } from '@rossum/api-client/hooks';
import {
  Chip,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@rossum/ui/material';
import { useHookInterfaces } from '../../../../extension-interop/hooks/useHookInterfaces';

type HookInterfacesProps = {
  hook: Hook;
};

export const HookInterfaces = ({ hook }: HookInterfacesProps) => {
  const { data: hookInterfaces } = useHookInterfaces({
    hook: hook.id,
  });

  if (!hookInterfaces?.results.length) {
    return null;
  }

  return (
    <List>
      {hookInterfaces?.results.map(hookInterface => (
        <ListItem key={hookInterface.id}>
          <ListItemText
            primary={
              <Typography variant="inherit">
                {hookInterface.name}{' '}
                <Chip color="info" label={hookInterface.type} />
              </Typography>
            }
            secondary={hookInterface.description}
          />
        </ListItem>
      ))}
    </List>
  );
};
